import { render, staticRenderFns } from "./TtsAudioElement.vue?vue&type=template&id=7d736510&scoped=true&"
import script from "./TtsAudioElement.vue?vue&type=script&lang=ts&"
export * from "./TtsAudioElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d736510",
  null
  
)

export default component.exports